import * as _ from 'lodash';

export const roundPrecision = (value: number, precision: number) => {
  return _.round(value, precision);
};
